import React, { useContext, useEffect, useState } from 'react'
import { useUspHotspot } from '../hooks/useUspHotspot'
import { capitalize } from './uspUtils'
import CollapsedUspModalT1 from './collapsed-usp-modal-t1'
import ExpandedUspModalT1 from './expanded-usp-modal-t1'
import { connect, useSelector } from 'react-redux'
import { UIContext, MediaContext } from '../context'
import { setIncrementClicked, setDecrementClicked, setToggleHotspotView, setIncrementClickedInterior, setDecrementClickedInterior, setToggleInteriorHotspot, setInteriorHotspotIndex, setHotspotClickedIndex } from '../../../Redux/Reducers/View360Reducer/View360ActionController'

const UspComponentT1 = (props) => {
  const { isExpanded, setIsExpanded } = useContext(UIContext);
  const interiorHotspotIndex = useSelector(state => state.view360Reducer.interiorHotspotIndex);
  const toggleInteriorHotspots = useSelector(state => state.view360Reducer.toggleInteriorHotspots);
  const {
    combinedHotspotData,
    currentUsp,
    dropdownSelection,
    toggleExpand,
    handleNext,
    handlePrev,
    handleNextCollapsed,
    handlePrevCollapsed,
    handleHotspotClick,
    toggleHotspotView,
    hotspotClickedIndex,
    useAutoCycle
  } = useUspHotspot({
    ...props,
    handleSelectThumbnail: props.handleSelectThumbnail
  })
  const { enterpriseId } = useContext(MediaContext);
  const [isSpanishEnterprise, setIsSpanishEnterprise] = useState(false);
  let spanishEnterprises = ['2d410b1b9','204fffd0d','858b283d5']  // TODO: get from backend
  let isSpanishEnterpriseFn = (enterpriseId) => {
      return spanishEnterprises.includes(enterpriseId);
  }
  useEffect(() => {
    if(isSpanishEnterpriseFn(enterpriseId)){
      setIsSpanishEnterprise(true);
    }
  }, [enterpriseId])
  useEffect(() => {
    setIsExpanded((interiorHotspotIndex !== -1 && dropdownSelection === "INT") ? true : false)
  }, [interiorHotspotIndex,toggleInteriorHotspots])

  useEffect(() => {
    setIsExpanded((hotspotClickedIndex !== -1 && dropdownSelection === "EXT") ? true : false)
  }, [hotspotClickedIndex])

  useAutoCycle(isExpanded);

  useEffect(() => {
    if(!props.toggleHotspotView || !toggleInteriorHotspots){
      setIsExpanded(false);
    }
  }, [props.toggleHotspotView, toggleInteriorHotspots]);

  useEffect(() => {
    if(toggleHotspotView && !isExpanded) {
      handleHotspotClick(setIsExpanded);
    }
  }, [toggleHotspotView, isExpanded, handleHotspotClick]);

  const handleToggleExpand = () => {
    toggleExpand(isExpanded, setIsExpanded);
  };

  return (
    <>
      {(combinedHotspotData?.length > 0) && (
        <div className={`w-full pb-1 px-2 ${isExpanded ? 'pt-2' : ''}`}>
          {!isExpanded && (
            <div className="bg-[#222830] rounded-lg shadow-lg">
              {/* <CollapsedUspModalT1
                onViewClick={handleToggleExpand}
                onPrev={handlePrevCollapsed}
                onNext={handleNextCollapsed}
                modalList={currentUsp || {}}
                dropdownSelection={dropdownSelection}
                currentItemType={currentUsp?.type}
                capitalize={capitalize}
                isSpanishEnterprise={isSpanishEnterprise}
              /> */}
            </div>
          )}
          
          {isExpanded && (
            <div className='bg-[#222830] rounded-xl shadow-lg'>
              <ExpandedUspModalT1
                onClose={handleToggleExpand}
                onPrev={handlePrev}
                onNext={handleNext}
                modalList={currentUsp || {}}
                dropdownSelection={dropdownSelection}
                currentItemType={currentUsp?.type}
                capitalize={capitalize}
                isSpanishEnterprise={isSpanishEnterprise}
              />
            </div>
          )}
        </div>
      )}
    </>
  )
}

const mapStateToProps = (state) => ({
  incrementClicked: state.view360Reducer.incrementClicked,
  decrementClicked: state.view360Reducer.decrementClicked,
  incrementClickedInterior: state.view360Reducer.incrementClickedInterior,
  decrementClickedInterior: state.view360Reducer.decrementClickedInterior,
  toggleInteriorHotspots: state.view360Reducer.toggleInteriorHotspots,
  interiorHotspotIndex: state.view360Reducer.interiorHotspotIndex,
  toggleHotspotView: state.view360Reducer.toggleHotspotView
});

const mapDispatchToProps = {
  setIncrementClicked,
  setDecrementClicked,
  setToggleHotspotView,
  setIncrementClickedInterior,
  setDecrementClickedInterior,
  setToggleInteriorHotspot,
  setInteriorHotspotIndex,
  setHotspotClickedIndex
};

export default connect(mapStateToProps, mapDispatchToProps)(UspComponentT1) 